import { SVGIconComponent } from './types';

export const Scan: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Selection-Indicator/Scan" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M6.592827,2 L2.68565401,2 C1.20227379,2 -3.29958283e-13,3.20227379 -3.29958283e-13,4.68565401 L-3.29958283e-13,8.592827 C-3.29958283e-13,8.99756212 0.327801219,9.32536334 0.732536334,9.32536334 C1.13727145,9.32536334 1.46507267,8.99756212 1.46507267,8.592827 L1.46507267,4.68565401 C1.46507267,4.01172058 2.01172058,3.46507267 2.68565401,3.46507267 L6.592827,3.46507267 C6.99756212,3.46507267 7.32536334,3.13727145 7.32536334,2.73253633 C7.32536334,2.32780122 6.99756212,2 6.592827,2 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M6.592827,17.5349273 L2.68565401,17.5349273 C2.01172058,17.5349273 1.46507267,16.9882794 1.46507267,16.314346 L1.46507267,12.407173 C1.46507267,12.0024379 1.13727145,11.6746367 0.732536334,11.6746367 C0.327801219,11.6746367 -3.29958283e-13,12.0024379 -3.29958283e-13,12.407173 L-3.29958283e-13,16.314346 C-3.29958283e-13,17.7977262 1.20227379,19 2.68565401,19 L6.592827,19 C6.99756212,19 7.32536334,18.6721988 7.32536334,18.2674637 C7.32536334,17.8627286 6.99756212,17.5349273 6.592827,17.5349273 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M21,8.592827 L21,4.68565401 C21,3.20227379 19.7977262,2 18.314346,2 L14.407173,2 C14.0024379,2 13.6746367,2.32780122 13.6746367,2.73253633 C13.6746367,3.13727145 14.0024379,3.46507267 14.407173,3.46507267 L18.314346,3.46507267 C18.9882794,3.46507267 19.5349273,4.01172058 19.5349273,4.68565401 L19.5349273,8.592827 C19.5349273,8.99756212 19.8627286,9.32536334 20.2674637,9.32536334 C20.6721988,9.32536334 21,8.99756212 21,8.592827 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M19.5349273,12.407173 L19.5349273,16.314346 C19.5349273,16.9882794 18.9882794,17.5349273 18.314346,17.5349273 L14.407173,17.5349273 C14.0024379,17.5349273 13.6746367,17.8627286 13.6746367,18.2674637 C13.6746367,18.6721988 14.0024379,19 14.407173,19 L18.314346,19 C19.7977262,19 21,17.7977262 21,16.314346 L21,12.407173 C21,12.0024379 20.6721988,11.6746367 20.2674637,11.6746367 C19.8627286,11.6746367 19.5349273,12.0024379 19.5349273,12.407173 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M9.76746367,7.08180966 L9.76746367,13.919128 C9.76746367,14.3238631 10.0952649,14.6516643 10.5,14.6516643 C10.9047351,14.6516643 11.2325363,14.3238631 11.2325363,13.919128 L11.2325363,7.08180966 C11.2325363,6.67707454 10.9047351,6.34927332 10.5,6.34927332 C10.0952649,6.34927332 9.76746367,6.67707454 9.76746367,7.08180966 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M12.697609,12.9421003 L12.697609,13.919128 C12.697609,14.3238631 13.0254102,14.6516643 13.4301453,14.6516643 C13.8348805,14.6516643 14.1626817,14.3238631 14.1626817,13.919128 L14.1626817,12.9421003 C14.1626817,12.5373652 13.8348805,12.209564 13.4301453,12.209564 C13.0254102,12.209564 12.697609,12.5373652 12.697609,12.9421003 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M6.83731833,12.9421003 L6.83731833,13.919128 C6.83731833,14.3238631 7.16511955,14.6516643 7.56985466,14.6516643 C7.97458978,14.6516643 8.302391,14.3238631 8.302391,13.919128 L8.302391,12.9421003 C8.302391,12.5373652 7.97458978,12.209564 7.56985466,12.209564 C7.16511955,12.209564 6.83731833,12.5373652 6.83731833,12.9421003 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M3.907173,12.9421003 L3.907173,13.919128 C3.907173,14.3238631 4.23497421,14.6516643 4.63970933,14.6516643 C5.04444444,14.6516643 5.37224566,14.3238631 5.37224566,13.919128 L5.37224566,12.9421003 C5.37224566,12.5373652 5.04444444,12.209564 4.63970933,12.209564 C4.23497421,12.209564 3.907173,12.5373652 3.907173,12.9421003 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M12.697609,7.08180966 L12.697609,10.5 C12.697609,10.9047351 13.0254102,11.2325363 13.4301453,11.2325363 C13.8348805,11.2325363 14.1626817,10.9047351 14.1626817,10.5 L14.1626817,7.08180966 C14.1626817,6.67707454 13.8348805,6.34927332 13.4301453,6.34927332 C13.0254102,6.34927332 12.697609,6.67707454 12.697609,7.08180966 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M6.83731833,7.08180966 L6.83731833,10.5 C6.83731833,10.9047351 7.16511955,11.2325363 7.56985466,11.2325363 C7.97458978,11.2325363 8.302391,10.9047351 8.302391,10.5 L8.302391,7.08180966 C8.302391,6.67707454 7.97458978,6.34927332 7.56985466,6.34927332 C7.16511955,6.34927332 6.83731833,6.67707454 6.83731833,7.08180966 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M3.907173,7.08180966 L3.907173,10.5 C3.907173,10.9047351 4.23497421,11.2325363 4.63970933,11.2325363 C5.04444444,11.2325363 5.37224566,10.9047351 5.37224566,10.5 L5.37224566,7.08180966 C5.37224566,6.67707454 5.04444444,6.34927332 4.63970933,6.34927332 C4.23497421,6.34927332 3.907173,6.67707454 3.907173,7.08180966 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
      <path
        d="M15.6277543,7.08180966 L15.6277543,13.919128 C15.6277543,14.3238631 15.9555556,14.6516643 16.3602907,14.6516643 C16.7650258,14.6516643 17.092827,14.3238631 17.092827,13.919128 L17.092827,7.08180966 C17.092827,6.67707454 16.7650258,6.34927332 16.3602907,6.34927332 C15.9555556,6.34927332 15.6277543,6.67707454 15.6277543,7.08180966 Z"
        id="Path"
        fill="#000000"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
